import Associat from './associat.vue';

export default Associat;
